import styled, { css } from "styled-components";
import { Form, Radio, Row, DatePicker } from "antd";
import {
  GhostButtonComponent,
  UnderlineLink,
  PillButton,
  PrimaryButtonComponent,
  DisplayFlex,
  ContentContainer,
  StepFlexRow,
  ErrorMessage
} from "../../../../CommonComponents/commonStyles";

const styles = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.primary};
  color:  ${props => props.theme.colors.primaryColor};
`;

const fontCommonStyle = css`
  font-family:${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.colors.tabHead};
`;

const cursorPointer = css`
  cursor: pointer;
`;

export const InfoMsg = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
`;

export const Err = styled(ErrorMessage)`
  margin-top: -20px;
  ${fontCommonStyle}
  letter-spacing : ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.error};
  line-height : ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const ErrFormItem = styled(ErrorMessage).attrs(props => ({
  className: "error-fields-ooa"
}))`
  ${fontCommonStyle}
  letter-spacing : ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.error};
  line-height : ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const PagesHeadingWrapper = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: ${props => props.marginBottom};

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2};
    width: 316px;
    height: 84px;
    line-height: ${props => props.theme.lineHeight.h3};
    color: ${props => props.theme.fontColors.headingColor};
  }
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 2.75rem 9% 0 9%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 2.75rem 6.4% 0 6.1%;
  }
`;
export const SubHeading = styled.div`
  ${fontCommonStyle}
  line-height: ${props => props.theme.lineHeight.primary};
  max-width: 980px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TabsContent = styled.div`
  line-height:${props => props.theme.lineHeight.h3};
  padding: 0 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 15px;
  }
`;

export const TooltipTextwrap = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.tableFont};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.white};
  text-align: center;
  display: flex;
  width: 170px;
  padding: 5px 5px;
`;

export const StepFlexRowMargin = styled(StepFlexRow)`
  margin-top: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 30px;

    .ant-col-lg-4 {
      margin-bottom: 20px;
    }
  }
`;



export const DescriptionPara = styled.p`
  color: ${props => props.theme.fontColors.thead};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  padding-top: 20px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  margin: 0px;
`;

export const FormContainer = styled(Form)`
  &&& {
    margin-top: ${props => props.theme.spacing.margins.YBetween};
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control {
      line-height: ${props => props.theme.lineHeight.noHeight};
    }
  }
`;

export const RadioButtonWrapper = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fontFamily.helveticaNeue}
`;

export const LabelWrapper = styled.div`
  ${fontCommonStyle}
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: ${props => props.theme.lineHeight.primary};
  margin-bottom: 4px;
  margin-top: 34px;
  content: none;
`;

export const PhoneLabelWrap = styled(LabelWrapper)`
  margin-top: 10px;
  margin-bottom: 4px;
`;
export const EmailLabelWrap = styled(LabelWrapper)`
  margin-top: 34px;
  margin-bottom: 20px;
`;

export const LabelWrapperDelivery = styled(PhoneLabelWrap)`
  margin-top: 34px;
  
`;

export const MainWrapper = styled.div`
  .ant-form-item-label {
    label::after {
      content: none;
    }
  }
`;

export const RadioWrapper = styled.div`
  .ant-radio-inner {
    border-color: ${props => props.theme.border.unchecked};
  }
  .ant-radio-inner::after {
    background-color: ${props => props.theme.backgroundColor.primaryColor};
  }
`;
export const PrimaryElement = styled.span`
  display: inline-block;
  margin-top: 2px;
`;
export const MailContentWrapper = styled.div`
  .ant-radio-wrapper {
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  
  ${fontCommonStyle}
  line-height: ${props => props.theme.lineHeight.primary};
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .ant-radio-inner {
    top: 3px;
    border-color: ${props => props.theme.border.unchecked};
  }
  .ant-radio-inner::after {
    background-color: ${props => props.theme.backgroundColor.primaryColor};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
    font-weight: ${props => props.theme.fontWeight.normal};
    margin-right: 14px;
  }
`;

export const MailContentWrapperfirst = styled(MailContentWrapper)`
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
  }
`;

export const Underlinelink = styled(UnderlineLink)`
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  ${styles}
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
    font-size: ${props => props.theme.fontSize.secondary};
    margin-left: 26px;
  }
`;

export const PillButtonAdd = styled(PillButton)`
  ${styles}
  font-size: ${props => props.theme.fontSize.secondary};
  background-color:${props => props.theme.backgroundColor.pill};
  margin: 16px 20px 0px 0;
  &:hover,
  &:focus {
    color: ${props => props.theme.backgroundColor.primaryColor};
    background: ${props => props.theme.backgroundColor.pill};
    border-color: ${props => props.theme.colors.lightGrey};
  }
`;

export const PillButtonAddressWrap = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 16px;
  }
`;

const buttonCommon = css`
  font-size: ${props => props.theme.fontSize.heading} !important;
  line-height: ${props => props.theme.lineHeight.subHeading} !important;
  letter-spacing: ${props => props.theme.letterSpacing.buttonText} !important;
  width: 150px !important;
  height: 50px !important;
  ${cursorPointer};
`;

export const GhostButton = styled(GhostButtonComponent)`
  ${buttonCommon}
  color: ${props => props.theme.colors.primaryColor};
  margin: 26px 30px -5px 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 15px 15px 0;
    flex: 1;
  }
`;

export const GhostButtonReset = styled(GhostButton)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 10px 0;
    flex: 1;
  }
`;

export const PrimaryButtonComponentNext = styled(PrimaryButtonComponent)`
  ${buttonCommon}
  text-align: center;
  margin-top: 26px;
  border-radius: 0;
  border: none;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100% !important;
    margin-top: 0;
  }
`;

export const PrimaryButtonComponentDisabled = styled(
  PrimaryButtonComponentNext
)`
  background-color: rgba(0, 103, 120, 0.3) !important;
  color: ${props => props.theme.colors.white} !important;
`;

export const DisplayFlexSpace = styled(DisplayFlex)`
  justify-content: space-between;
`;

export const DisplayFlexSpaceMobile = styled(DisplayFlexSpace)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    padding-top: 16px;
  }
`;

export const SelectTabsWrapper = styled.div`
  .ant-tabs-bar {
    margin: 0;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    border-bottom: 1px solid #d4d4d4;
    .ant-tabs-nav-container {
      height: 55px !important;
    }
  }

  .ant-tabs-tab:hover {
    color: unset;
  }

  .ant-tabs.ant-tabs-card {
    .ant-tabs-card-bar {
      .ant-tabs-tab {
        margin-right: 0;
        border: none;
        padding-left: 0;
        padding-right: 0;
        border-top: 4px solid rgba(0, 103, 120, 0.1);
        height: 56px;
        border-bottom: 1px solid ${props => props.theme.colors.border};
        background-color:${props => props.theme.colors.greyColor} !important;
      }

      .ant-tabs-tab.ant-tabs-tab-active {
        border-left: 1px solid ${props => props.theme.colors.border};
        border-right: 1px solid ${props => props.theme.colors.border};
        color: ${props => props.theme.colors.primaryColor};
        border-top: none;
        border-top: 4px solid ${props => props.theme.colors.primaryColor} !important;
        height: 56px;
        border-bottom: none;
        background-color: ${props => props.theme.colors.white} !important;
      }
    }
  }

  .ant-tabs-tab {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    text-align: center;
    background-color:${props => props.theme.colors.border} !important;
    border-radius: 0 !important;
    border-right: 1px solid :${props => props.theme.colors.border} !important;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
      letter-spacing: ${props => props.theme.letterSpacing.normal};
    }
  }
`;

export const SelectOptionGenderWrapper = styled.div`
  .ant-select-selection {
    .ant-select-arrow {
      i {
        display: block;
      }
    }
  }

  .ant-select-arrow {
    color: ${props => props.theme.colors.dropdownArrow};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${props => props.theme.colors.border};
    background: ${props => props.theme.backgroundColor.pill};
  }
`;

export const SelectOptionMainWrapper = styled.div`
  .ant-select-dropdown {
    border: 1px solid ${props => props.theme.colors.border};
    border-top: none;
    border-radius: 0;
    box-shadow: -7px 9px 15px 0 rgba(223, 223, 223, 0.5);
    li {
      border: none;      
      padding: 5px 20px;
    }
    li:hover {
      color: ${props => props.theme.colors.darkBlue};
      background-color: #e6f7ff;
    }
  }

  .ant-select-dropdown:after {
    bottom: 0;
  }
`;

export const SelectOptionWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.tboby};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.twoRem};
  padding-top: 5px !important;
  font-weight: ${props => props.theme.fontWeight.normal};
  
`;

const titleCommmon = css`
  ${fontCommonStyle}
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
`;
export const TitleWrapper = styled.div`
  ${titleCommmon}
  line-height:${props => props.theme.lineHeight.primary};
  letter-spacing : ${props => props.theme.letterSpacing.zero};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TitleWrapperTitle = styled(TitleWrapper)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0;
  }
`;

export const ExtraContentWrapper = styled.div`
  ${titleCommmon}
  padding-top: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: none;
    margin-bottom: 150px;
  }
`;

export const MiddleName = styled.div`
  color: ${props => props.theme.colors.tabHead};
  font-size: ${props => props.theme.fontSize.primary};
`;

export const InputWrapper = styled.div`
  input,
  .ant-select-selection--single {
    height: ${props => props.height ? props.height: '40px !important'};
  }

  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: ${props => props.theme.colors.border};
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid ${props => props.theme.colors.border};
  }

  .ant-input {
    border-radius: 0;
    color: ${props => props.theme.fontColors.textColor};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  .ant-input.has-error:hover {
    border: 1px solid ${props => props.theme.colors.border} !important;
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }
`;

export const SelectWrapperGraded = styled(InputWrapper)`
  .ant-select-selection {
    background: ${props => props.theme.backgroundColor.cardDark} !important;
    border: 1px solid ${props => props.theme.colors.border};
  }

  .ant-select-arrow-icon {
    display: block;
  }

  .ant-input {
    border: 1px solid ${props => props.theme.colors.border};
    font-size: ${props => props.theme.fontSize.primary};
  }

  .ant-select-selection-selected-value {
    color: ${props => props.theme.colors.tabHead};
    font-size: ${props => props.theme.fontSize.primary};
  }
`;

export const InputWrapperGraded = styled(InputWrapper)`
  input {
    padding: 0 20px;
  }

  input::placeholder {
    color: ${props => props.theme.colors.border};
  }

  .ant-select-selection-selected-value {
    color: ${props => props.theme.colors.tabHead};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size:  ${props => props.theme.fontSize.secondary};
    }
  }

  .ant-select-selection__rendered {
    margin: 0;
  }
`;

export const SecurityNumWrap = styled.div`
  input {
    height: 45px;
  }
  .ant-input {
    border-radius: 0;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }

  .ant-input-suffix {
    display: none;
  }
`;

export const SpanWrap = styled.span`
  white-space: pre-wrap;
  span {
    display: inline-block;
    vertical-align: top;
  }
`;

export const TitleWrapperPrimary = styled.div`
  margin-top: ${props =>
    props.marginTop === undefined ? "30px" : props.marginTop};
  height: 70px;
  margin-left: 6px;
  ${titleCommmon};
  display: flex;
  align-items: center;
  .ant-radio-wrapper {
    margin-right: 20px;
  }
  .ant-radio-wrapper,
  a {
    margin-top: 0px;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: 0;
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 40px;
  }

  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 16px;
  }
`;

export const TitleWrapperPrimaryAdress = styled(TitleWrapperPrimary)`
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 60px;
  }
`;

export const NoResultsWrap = styled.div`
  margin-left: 11px;
`;
export const InputWrapperfixedwidth = styled.div`
  input,
  .ant-select-selection--single {
    height: 40px !important;
    width: 300px;
  }

  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: ${props => props.theme.fontColors.placeholder};
    font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid ${props => props.theme.colors.border};
  }

  .ant-input {
    border-radius: 0;
    color: ${props => props.theme.border.inputBox};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
      width : 100%;
    }   
  }
  .ant-input.has-error:hover {
    border: 1px solid ${props => props.theme.colors.border} !important;
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }

`;
export const InputWrapperdropFixedwidth = styled.div`
  .ant-select-selection--single {
    height: 40px !important;
    width: 300px;
  }
  .ant-select-selection-selected-value,
  .ant-select-search__field {
    line-height: ${props => props.theme.lineHeight.h2};
    vertical-align: middle;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
      display: flex !important;
      align-items: center;
      height: 100%;      
    }
    div {
      font-size: ${props => props.theme.fontSize.primary};
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
      }
    }
  }

  .ant-select-selection__placeholder {
    font-size:${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.placeholder};
    padding: 0 9px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
  }
  .ant-select-selection {
    border-radius: 0;
    border: 1px solid ${props => props.theme.colors.border};
  }

  .ant-select-selection {
    box-shadow: none;
  }

  .ant-select-selection__rendered {
    height: 100%;
    padding: 0 9px;
  }

  .ant-select-arrow {
    color: ${props => props.theme.colors.dropdownArrow};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${props => props.theme.colors.border};
    background: ${props => props.theme.backgroundColor.pill};
  }
`;
export const InputWrapperDrop = styled.div`
  .ant-select-selection--single {
    height: 40px !important;
  }
  .ant-select-selection-selected-value,
  .ant-select-search__field {
    line-height: ${props => props.theme.lineHeight.h2};
    vertical-align: middle;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
      display: flex !important;
      align-items: center;
      height: 100%;
    }
    div {
      font-size: ${props => props.theme.fontSize.primary};
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
      }
    }
  }

  .ant-select-selection__placeholder {
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.colors.border};
    padding: 0 9px;
  }
  .ant-select-selection {
    border-radius: 0;
    border: 1px solid ${props => props.theme.colors.border};
  }

  .ant-select-selection {
    box-shadow: none;
  }

  .ant-select-selection__rendered {
    height: 100%;
    padding: 0 9px;
  }

  .ant-select-arrow {
    color: ${props => props.theme.colors.dropdownArrow};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${props => props.theme.colors.border};
    background: ${props => props.theme.backgroundColor.pill};
  }
`;

export const ChangeSecurityWrapperDrop= styled(InputWrapperDrop)`
  .ant-select-selection--single {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
  .ant-select-selection__rendered {
    padding: 0px 0px;
  }
  &&.securityQuesDropdown {
    @media (max-width: 991px) {
      .ant-select-selection-selected-value {
        font-size: ${props => props.theme.fontSize.secondary} !important;
        color: ${props => props.theme.fontColors.textColor} !important; 
      }
    }
  }
`;


export const WebTitle = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: ${props => props.theme.lineHeight.popUpHeading};
  color: ${props => props.theme.fontColors.headingColor};
  padding: 0 20px 0 18px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 0 5px 5px;
  }
  @media only screen and (min-width: 320px) and (max-width: 321px) {
    font-size: 21px;
    padding: 0 0 5px 0px;
  }
`;

export const NoChange = styled.div`
  ${fontCommonStyle};
  line-height: ${props => props.theme.lineHeight.tertiaryUpdated};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 7px;
  }
`;

export const NoChangeSpace = styled(NoChange)`
  margin-bottom: 45px;
  width: 172px;
  display: flex;
  justify-content: space-between;
  margin-top: -3.25rem;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: 0;
  }
`;

export const WebAccessHeaderWrapper = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 78px;
  }
`;

export const Align = styled.span`
  display: flex;
  align-items: center;
`;

export const AlignContent = styled.span`
  display: flex;
  align-items: center;
  .ant-checkbox-wrapper {
    margin-bottom: 9px !important;
  }
`;


export const CheckboxWrapper = styled.div`
 .ant-checkbox-wrapper{
display: flex;
}
.ant-checkbox-checked .ant-checkbox-inner{
  background-color: ${props => props.theme.colors.primaryColor};
  border-color: ${props => props.theme.colors.primaryColor};
}
.ant-checkbox{
  top: 4px;
}
margin-bottom: 20px;
.ant-checkbox .ant-checkbox-inner::after {
  border-color: white;
  left: 27%;
  height: 10px;
  width: 6px;
}
`

export const CheckboxContent = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.primary};
line-height: ${props => props.theme.lineHeight.primary};
color: ${props => props.theme.fontColors.textColor};
font-style: normal;
font-stretch: ${props => props.theme.fontStretch.normal};
letter-spacing: ${props => props.theme.letterSpacing.normal};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
}`

export const RadioWrappered = styled.div`
  &&& {
    .ant-radio {
      margin-top: -4px;
    }
  }
  
`;
export const DisplayFlexAlign = styled(DisplayFlex)`
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    margin-right: 15px;
    align-items: initial;
  }
`;

export const DisplayFlexSpaceWidth = styled(DisplayFlexSpace)`
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    align-items: center;
  }
`;

export const WebAccessInfoWrapper = styled.div`
  .ant-collapse-item {
    background:${props => props.theme.colors.white};
    border-bottom: none;
  }

  .ant-collapse-content {
    border-radius: 0 !important;
    .ant-collapse-content-box {
      padding: 0 32px 6px;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0 20px 6px;
      }
    }
  }

  .ant-collapse-content {
    border-top: none;
  }

  .ant-collapse {
    border-radius: 0;
    border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  }

  margin-bottom: 50px;
  margin-top: 16px;
`;

export const ExpandWrap = styled.div`
  margin: 5px 14px 0 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 4px 0 0;
  }
`;

export const AdvisoryFormWrapper = styled.div`
  .ant-form {
    margin-top: 20px !important;
  }
`;

export const RowWrapper = styled(Row)`
  /* margin-top: 6px; */
`;

export const FlexWrap = styled.div`
  display: flex;
  align-items: baseline;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
  }
`;

export const EmailWrapper = styled.div`
  .ant-checkbox-wrapper {
    margin-top: 8px;
    .ant-checkbox-inner {
      width: 15px;
      height: 15px;
    }
    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: ${props => props.theme.backgroundColor.primaryColor};
        border-color: ${props => props.theme.border.teal};
      }
    }
  }
`;
export const EmailTitleWrapper = styled(TitleWrapper)`
  margin-right: 20px;
`;

export const CheckWrap = styled.span`
  ${fontCommonStyle}
  font-size: ${props => props.theme.fontSize.tertiary} !important;
  line-height: ${props => props.theme.lineHeight.primary} !important;
`;

export const IconWrap = styled.div`
  float: right;
  ${cursorPointer};
  margin-top: 23px;
  margin-right: -50px;
  i {
    font-size: ${props => props.theme.fontSize.h5};
    color: #1d1d1b;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right: 0;
  }
`;

export const HeightDiv = styled.div`
  height: ${props => props.height}
  border-bottom: ${props => props.borderBottom}
  margin-top: ${props => props.marginTop}
`;

export const HeightDivBottom = styled.div`
  height: 12%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
`;

export const InfoContentWrapper = styled.div`
  padding: 0 6% 0 6%;
  position: fixed;
  background: ${props => props.theme.colors.white};
  width: 77%;
  height: 74.6%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 594px;
    width: 87.5%;
  }
`;

export const InfoWrapper = styled.div`
  position: fixed;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 120vw;
  height: 190vh;
  top: 0;
`;

export const PopHeader = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: ${props => props.theme.lineHeight.popUpHeading};
  color: ${props => props.theme.fontColors.headingColor};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15% @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const QASectionWrapper = styled.div`
  margin: 15px 0 9px 0;
  margin-bottom: 24px;
`;

export const QASectionWrapperLast = styled(QASectionWrapper)`
  margin-bottom: 9px;
`;
export const QuestionWrap = styled.div`
  ${fontCommonStyle};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: ${props => props.theme.lineHeight.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const QASection = styled.div`
border-top: 2px solid ${props => props.theme.border.filledTabsInactive};
  border-bottom: 2px solid ${props => props.theme.border.filledTabsInactive};
  height: 66.4%;
  overflow: scroll;
`;

export const AnswerWrap = styled.div`
  ${fontCommonStyle};
  line-height: ${props => props.theme.lineHeight.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const PrimaryButtonOkay = styled(PrimaryButtonComponent)`
  width: 200px !important;
  border-radius: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.buttonText};
  ${cursorPointer}
  border: none;
  z-index: 10003;
`;

export const DisplayFlexOkay = styled(DisplayFlex)`
  justify-content: center;
  align-items: center;
  height: 18.6%;
`;

export const TitleMarginTop = styled.div`
  margin-top: 16px;
`;

export const TitleMarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const DeliveryMarginBottom = styled.div`
  margin-bottom: 20px;
`;

export const AddressWrap = styled.div`
  margin-bottom: -10px;
`;

export const AdvisorMargin = styled.div`
  margin-bottom: 50px;
`;

export const SelectdropwownStyles = styled.div`
  .ant-select-dropdown {
    top: 40px !important;
    width: 100% !important;
  }
`;
export const InputMargin = styled.div`
  .ant-form-item {
    margin-bottom: 40px;
  }
`;
export const WrapLabel = styled.div`
  &&& {
    .ant-form-item-label {
      margin-bottom: 10px;
    }
  }
  &&& {
    .ant-form-item-label > label::after {
      margin: 0;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    &&& {
      .ant-form-item-label {
        padding: 0;
      }
    }
  }
`;

export const WebAccessInfoMargin = styled.div`
  .ant-form-item {
    margin-bottom: ${props => (props ? props.marginBottom : "20px")};
  }
`;

export const AdressButtonMargin = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;
export const DatePickerWrapper = styled.div`
  &&& {
    .ant-calendar {
      background: red;
      width: 327px;
    }
  }
`;

export const TabWrap = styled.div`
  line-height: ${props => props.theme.lineHeight.h2}
`;

export const CalenderDisabling = styled(DatePicker)`
  .ant-input-disabled + i.anticon {
    cursor: not-allowed;
  }
`;

export const ExtraContentMobile = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.tabHead};
  margin-bottom: 20px;
`;
//##################################INVITED INTERSTED PARTY
export const WrappingDiv = styled.div`
text-align: center;
display: flex;
align-items: center;
justify-content: center;
height: 15% @media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.h5};
}
`;

export const WrappingHeading = styled.div`
margin-bottom: 30px;
text-align: center;
display: flex;
align-items: center;
justify-content: center;
height: 15% @media only screen and (min-width: 320px) and (max-width: 767px) {
font-size: 24px;}
width: 100%;
font-family: ${props => props.theme.fontFamily.berkeleyStd};
font-size: ${props => props.theme.fontSize.h4};
line-height:${props => props.theme.lineHeight.secondary};
letter-spacing:${props => props.theme.letterSpacing.normal};
color: ${props => props.theme.fontColors.headingColor};
margin-top : 30px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.h5};
}
`;
export const AccessRoleContent = styled.div`
margin-top : 30px;
text-align: center;
display: flex;
align-items: center;
justify-content: center;
height: 15% @media only screen and (min-width: 320px) and (max-width: 767px) {
font-size: ${props => props.theme.fontSize.h4}; width: 150px;}
`;

export const ContentCol = styled.div`
// width: 253px;
`;
export const ContentColText =styled.div`
  
  height: 20px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.tableFont};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.tabHead};

`;
export const FullCol = styled.div`
// width: 253px;
`;

export const Path7 = styled.div`
width: 253px;
height: 20px;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size:  ${props => props.theme.fontSize.secondary};
line-height: ${props => props.theme.lineHeight.tableFont};
letter-spacing: ${props => props.theme.letterSpacing.normal};
color: ${props => props.theme.colors.tabHead};
margin-top : 124px;

`;
export const GhostButtonClose = styled(GhostButtonComponent)`
  ${buttonCommon}
  color: ${props => props.theme.colors.primaryColor};
  margin: 26px 30px -5px 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 15px 15px 0;
    flex: 1;
  }
`;
export const InfoContentWrapperDiv = styled.div`
  padding: 0px 30px 30px 30px;
  position: fixed;
  background: ${props => props.theme.colors.white};
  width:1067px;
  top: 50%;
  left: 50%;
  overflow-x: hidden;
  overflow-y: auto;
  transform: translate(-50%, -50%);
  z-index: 10002;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 594px;
    width: 87.5%;
    overflow:scroll;
  }
  @media only screen and (min-width: 768px) {
    width: 1067px !important;
    max-width: calc(100vw - 44px);
    margin: 8px auto;
  }
`;
//##################################INVITED INTERSTED PARTY


export const MyAccountMandatoryMessage = styled.div`
  margin-top: 10px;
`
export const InvitedHeading = styled.div`
font-family: ${ props => props.theme.fontFamily.berkeleyStd};
width: 640px;
font-size: ${ props => props.theme.fontSize.h1};
line-height: ${ props => props.theme.lineHeight.h1};
font-style: normal;
font-stretch: ${ props => props.theme.fontStretch.normal};;
color: ${ props => props.theme.fontColors.headingColor};
margin-bottom: 30px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${ props => props.theme.fontSize.h2};
  width: 316px;
  height: 84px;
  line-height: ${ props => props.theme.lineHeight.h1};
  color: ${ props => props.theme.fontColors.headingColor};
}
`;
export const GhostButtonBack = styled(GhostButtonComponent)`
  width: 150px !important;
  height: 50px !important;
  color: ${props => props.theme.backgroundColor.primaryColor};
  margin-top: 49px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 50px 15px 10px 0;
    width:100% !important;
  }
  @media screen and (min-width:0\0) {
    width: 15%;
  }
`;
export const SuccessDesc = styled.p`
  color: ${props => props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.primary};
  padding-top: 15px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  margin-top: 30px;
  margin-right: 337px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size:  ${props => props.theme.fontSize.secondary};
    width: 316px;
    height: 30px;
    line-height: ${props => props.theme.lineHeight.pageHeadingMob};
    color: ${props =>props.theme.fontColors.textColor};
    margin-top: 21px;
    margin-bottom:50px;
  } 
`;
export const ButtonDivider = styled.div`
  .ant-divider {   
    background : ${props => props.theme.colors.border}
    height: 1px;
    margin-top: 49.5px;
    @media only screen and (min-width : 320px) and (max-width : 767px) {
    height:1px;
    margin-top:110px;
    }
  }
`;
export const SelectComponentWrap = styled.div`
  .ant-form-item-control {
    line-height: unset;
  }
`;
export const zipCodeErrorDiv = {
  marginTop: '4px'
}


export const ShowErrorMessage = styled.div`
  margin-top: 15px;
  ${fontCommonStyle}
  color: ${props => props.theme.fontColors.error};
  line-height: 1.25;
  letter-spacing: 0.6px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const CheckBoxWrappered = styled.div`
  .ant-checkbox .ant-checkbox-inner::after {
    border-color: white;
    left: 27%;
    height: 8px;
    width: 6px;
  }
`;